import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import Users from '../../pages/People/Users'
import UserProfile from '../../pages/UserProfile'

const UsersRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:id`} component={UserProfile} />

      <Route path={path} component={Users} />
    </Switch>
  )
}

export default UsersRoute
